import gettext from '@sdk/lang/gettext';

import { ComposeConversationHeaderWithPadding } from '@web/conversations/ComposeConversation/ComposeConversationHeader/ComposeConversationHeader';
import EditIcon from '@web/assets/svg/Icons/48/groups-blue.svg';

export const ConversationEditHeader = () => (
  <ComposeConversationHeaderWithPadding>
    <EditIcon />
    <ComposeConversationHeaderWithPadding.Title>
      {gettext('Edit conversation')}
    </ComposeConversationHeaderWithPadding.Title>
  </ComposeConversationHeaderWithPadding>
);
